// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.heatmapHt[data-v-ed186318] {\n  height: 320px;\n  overflow: hidden;\n}\n#cal-heatmap[data-v-ed186318] {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.content-panel1[data-v-ed186318] {\n  height: initial;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
